import React, {useState} from 'react';
import {Select, Space, Typography} from 'antd';

const {Text} = Typography;

export interface UseTablePaginationProps {
  defaultCurrent?: number;
  defaultPageSize?: number;
  itemName?: string;
}

export const useTablePagination = ({
  defaultCurrent = 1,
  defaultPageSize = 20,
  itemName = 'items',
}: UseTablePaginationProps = {}) => {
  const [current, setCurrent] = useState(defaultCurrent);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [total, setTotal] = useState(0);

  const handlePageChange = (page: number) => {
    setCurrent(page);
    window.scrollTo({top: 0, behavior: 'smooth'});
  };

  const paginationConfig = {
    current,
    pageSize,
    total,
    showSizeChanger: false,
    showQuickJumper: true,
    showTotal: (tot: number, range: [number, number]) =>
      `${range[0]}–${range[1]} of ${tot} ${itemName}`,
    onChange: handlePageChange,
  };

  const paginationSelector = (
    <Space size={4}>
      <Text type="secondary" style={{fontSize: 13}}>
        Rows:
      </Text>
      <Select
        value={pageSize}
        size="small"
        style={{width: 70}}
        onChange={val => {
          setPageSize(val);
          setCurrent(1);
        }}
        options={[
          {value: 10, label: '10'},
          {value: 20, label: '20'},
          {value: 50, label: '50'},
          {value: 100, label: '100'},
        ]}
      />
    </Space>
  );

  return {
    current,
    setCurrent,
    pageSize,
    setPageSize,
    total,
    setTotal,
    paginationConfig,
    paginationSelector,
  };
};
